import src from "IMAGE";
export default { src, width: 732, height: 271, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
